import { DiscoveryWallState } from '../../../models';
import { DISCOVERY_WALL_MUTATIONS_KEYS } from '../discovery-wall.const';
import { DiscoveryWallMutation } from '../discovery-wall.interfaces';
import { getInitialDiscoveryWallState } from '../discovery-wall.state';

export class ResetDiscoveryWallStateMutation implements DiscoveryWallMutation {
  mutations = {
    [DISCOVERY_WALL_MUTATIONS_KEYS.resetDiscoveryWallState]: (state: DiscoveryWallState) => {
      const { clicksRecommendations, userRecommendations, queriesRecommendations, sectionRecommendations } = getInitialDiscoveryWallState();
      state.clicksRecommendations = clicksRecommendations;
      state.userRecommendations = userRecommendations;
      state.queriesRecommendations = queriesRecommendations;
      state.sectionRecommendations = sectionRecommendations;
    }
  };
}
